import { render, staticRenderFns } from "./show_signature_pad.vue?vue&type=template&id=e8673e5c&"
import script from "./show_signature_pad.vue?vue&type=script&lang=js&"
export * from "./show_signature_pad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports